import { render, staticRenderFns } from "./ExibirExcecoesProtesto.vue?vue&type=template&id=6c69d66d&"
import script from "./ExibirExcecoesProtesto.vue?vue&type=script&lang=js&"
export * from "./ExibirExcecoesProtesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports